import { render } from "./BookWorkersCard.vue?vue&type=template&id=3f164c9f"
import script from "./BookWorkersCard.vue?vue&type=script&lang=js"
export * from "./BookWorkersCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__